/**
 * Прив’язка полів юридичного контуру до понять довідника (значок «?» біля підпису поля).
 * Ключ — `legal.<сутність>.<поле>`, значення — термін словника (GET /api/v1/kb/glossary).
 * Мапу підключено в features/knowledge/fieldTerms.ts (FIELD_TERMS). Поле в інтерфейсі: <Field term="legal.<сутність>.<поле>">.
 * Ключі, які сервер уже прив’язує через `fieldKeys` понять (legal.service.category, legal.service.portfolio,
 * legal.oe.clientNeed, legal.matter.clientNeed), тут не дублюються.
 */
export const LEGAL_FIELD_TERMS: Readonly<Record<string, string>> = {
  // Замовлення «Відпрацювання»
  'legal.matter.qualityLevel': 'Q1–Q3',
  'legal.matter.startDocuments': 'Клієнту на старті',
};
